/* section.tsx generated by @compiled/babel-plugin v0.40.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ywu1ule%3Aafter%7Bdisplay%3Ablock%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._cfu11ule%3Abefore%7Bdisplay%3Ablock%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1qdgi2wt%3Aafter%7Bheight%3A6px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kfgti2wt%3Abefore%7Bheight%3A6px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._aetrb3bt%3Aafter%7Bcontent%3A%22%22%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1kt9b3bt%3Abefore%7Bcontent%3A%22%22%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p3hi2wt%20%5Bdata-ds--menu--heading-item%5D%7Bmargin-block-end%3A6px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1l6bgktf%20%5Bdata-ds--menu--heading-item%5D%7Bmargin-block-start%3A20px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._osbldlk8%20%5Bdata-ds--menu--heading-item%5D%3Afirst-of-type%7Bmargin-block-start%3A14px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._auo4rdoj%20%5Bdata-ds--menu--skeleton-heading-item%5D%7Bmargin-block-end%3A9px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._hp2110yn%20%5Bdata-ds--menu--skeleton-heading-item%5D%7Bmargin-block-start%3A25px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mfv8jkm%20%5Bdata-ds--menu--skeleton-heading-item%5D%3Afirst-of-type%7Bmargin-block-start%3A19px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bg41n1a%3Afocus%7Boutline-offset%3A-1px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo1wug%7Boverflow-x%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m91wug%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zkb7n%7Bflex-shrink%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zidpf%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._mqm2lllh%7Bborder-block-start%3Avar(--ds-border-width%2C1px)%20solid%20var(--ds-menu-seperator-color%2Cvar(--ds-border%2C%230b120e24))%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%5Bdata-section%5D%2B._n7cnyjp0%7Bmargin-block-start%3A-6px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18zru2gc%7Bpadding-inline%3Avar(--ds-space-100%2C8px)%7D");
import { Children, forwardRef, Fragment, type Ref } from 'react';
import HeadingItem from '../menu-item/heading-item';
import type { SectionProps } from '../types';
const itemHeadingTopMargin = 20;
const itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const skeletonHeadingHeight = 8;
const skeletonHeadingMarginOffset = 3;
const skeletonHeadingTopMargin = itemHeadingTopMargin + (itemHeadingContentHeight - skeletonHeadingHeight) - skeletonHeadingMarginOffset;
const sectionPaddingTopBottom = 6;
const styles = {
  root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
  scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
  unscrollable: "_1o9zidpf",
  thinSeparator: "_mqm2lllh",
  noSeparator: "_n7cnyjp0",
  sideNavSectionHeading: "_18zru2gc"
};

/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */
const Section: React.ForwardRefExoticComponent<React.PropsWithoutRef<SectionProps> & React.RefAttributes<HTMLElement>> = forwardRef<HTMLElement, SectionProps>(({
  children,
  title,
  titleId,
  testId,
  isScrollable,
  hasSeparator,
  id,
  isList = false,
  isSideNavSection = false,
  label,
  // Although this isn't defined on props it is available because we've used
  // Spread props below and on the jsx element. To forcibly block usage I've
  // picked it out and supressed the expected type error.
  // @ts-expect-error
  className: UNSAFE_className,
  ...rest
}, ref) => {
  const content = isList ? <ul style={{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    margin: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    padding: 0
  }}>
				{Children.map(Children.toArray(children), (child, index) => <li
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    style={{
      listStyleType: 'none',
      margin: 0,
      padding: 0
    }} key={index}>
						{child}
					</li>)}
			</ul> : children;
  const childrenMarkup = title !== undefined ? <Fragment>
					<HeadingItem testId={testId && `${testId}--heading`} aria-hidden
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
    className={ax([isSideNavSection && styles.sideNavSectionHeading])}>
						{title}
					</HeadingItem>
					{content}
				</Fragment> : <Fragment>{content}</Fragment>;
  return <div {...rest}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  className={ax([styles.root, isScrollable ? styles.scrollable : styles.unscrollable, hasSeparator ? styles.thinSeparator : styles.noSeparator, UNSAFE_className])} id={id}
  // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
  // We have made a deliberate choice to leave this behaviour as is.
  aria-label={title || label} aria-labelledby={titleId} data-testid={testId} role="group" data-section ref={(ref as Ref<HTMLDivElement>)}>
				{childrenMarkup}
			</div>;
});
export default Section;